import React, { useState, useEffect } from "react";

import { Col, Fade, Form, FormGroup, Input, Label, Row } from "reactstrap";
import Moment from "moment";
import "moment/locale/es";
import axios from "./axios-config";
import {FaFile, FaSearch,FaPlus, FaMinus,FaWhatsapp, FaUpload, FaDoorOpen, FaSave, FaSignOutAlt, FaTimes, FaPaperPlane } from "react-icons/fa";
import { Pie } from "react-chartjs-2";
import "./EstilosTabla.css";
import $ from "jquery";
import swal from "./i18n/swal";

import BootStrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import { Modal, Button } from "react-bootstrap";
import Tabs from "./tab0.js";
import Bitacora from "./tab.js";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import paginationFactory from "react-bootstrap-table2-paginator";
import Chart from "chart.js";
import Drop from "./dropzoneSingle.js";

import { FileText } from "lucide-react";
import { useIdioma } from "./context/IdiomaContext";
import DescargarDoc from "./Liquidacion/DescargarDoc.js";
import DocPendientes from "./DocPendientes.js"


const Pagination = () => {
  const { t } = useIdioma();
  const [modalInfo2, setModalInfo2] = useState([]);
  const [files, setFiles] = useState([]);
  const [modalInfo1, setModalInfo1] = useState([]);
  const [modalInfo3, setModalInfo3] = useState([]);
  const [modalInfo4, setModalInfo4] = useState([]);
  const [modalInfo5, setModalInfo5] = useState([]);
  const [modalInfo6, setModalInfo6] = useState([]);
  const [showModal3, setShowModal3] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal1, setShowModal1] = useState(false);
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleClose2 = () => setShow2(false);
  const handleClose3 = () => setShow3(false);
  const handleShow1 = () => setShow1(true);
  const handleShow2 = () => setShow2(true);
  const handleShow3 = () => setShow3(true);
  const [datoAsesor, setdatoAsesor] = useState([]);
  const [mostrarGrafica, setMostrarGrafica] = useState(true);
  const enviar_contacto = () => {
    return window.open("https://wa.me/502" + sessionStorage.getItem("datosAsesor"));
  };
  let tip = "";
  let tipo = "";
  let dip = 0;
  let datos = [];
  let validador = 0;
  let contador = 0;
  let miVariables = window.variableP;
  //console.log("aqui reclamo: ",miVariables);
  let fechaInicioVigencia = new Date(window.variableP.idPoliza.vigenciaInicio);  

// Crear una copia para no modificar la original
let fechaInicio = new Date(fechaInicioVigencia);
fechaInicio.setFullYear(fechaInicio.getFullYear() - 1);

  let fechaFinal = new Date(window.variableP.idPoliza.vigenciaFin);
  if (miVariables.tgmReclamoList.length>0 ) {
    contador = miVariables.tgmReclamoList.length
      ? miVariables.tgmReclamoList.length
      : 0;
  } else {
    swal("Información", "Esta póliza no poseé reclamos ingresados", "info");
    contador = 999999;
  }

  let miVariable = "";
  let countPro = 0;
  let countFina = 0;
  let countIngresado=0;
  let countProceso=0;
  let countLiquidado=0;
  let countCerrado=0;
  let countAnulado=0;
  let countOtr = 0;
  let countDat = 0;
  var state;
  if (contador == 0) {
    //console.log(miVariables.TGmReclamoList.treclamo.idReclamo);
    //console.log("hola");
    ///////////////////////////////////77

    if (miVariables.tgmReclamoList.idDependiente === undefined) {
      //  //console.log("ingrse"+i);
      window.infoCertificado = "Elfrid";
    } else {
      ////console.log("ingse servicio"+i);
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/dependiente/` +
            miVariables.tgmReclamoList.idDependiente,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
            },
          }
        )
        .then((json) => {
          if (json.status == 200) {
            window.infoDependiente =
              json.data.primerNombre + " " + json.data.primerApellido;
            window.relacion = json.data.parentesco;
          }
        });
    }

    let dip = miVariables.tgmReclamoList.idDependiente
      ? miVariables.tgmReclamoList.treclamo.idReclamo
      : 0;

    if (miVariables.idDependiente === undefined) {
      tip = window.clienteTitular;
      tipo = "Titular";
    } else {
      tip = window.infoDependiente;
      if (window.relacion == 0) {
        tipo = "NO ESPECIFICADO";
      } else if (window.relacion == 1) {
        tipo = "CONYUGE";
      } else if (window.relacion == 2){
        tipo = "HIJO(A)";
      }else
      {
        tipo = "";
      }
    }

    //console.log(miVariables.tgmReclamoList.treclamo.idEstado);
    /*if (miVariables.tgmReclamoList.treclamo.idEstado == 1) {
      state = "PROCESO";
    } else if (miVariables.tgmReclamoList.treclamo.idEstado == 2) {
      state = "FINALIZADO";
    } else {
      state = "PROCESO";
    }*/
    /*
    if (miVariables.tgmReclamoList.treclamo.idEstado == 1) {
        state = "PROCESO";
      } else if (miVariables.tgmReclamoList.treclamo.idEstado == 2) {
        state = "CERRADO";       
      } else if (miVariables.tgmReclamoList.treclamo.idEstado == 3) {
        state = "RECHAZADO";
      
      } else if (miVariables.tgmReclamoList.treclamo.idEstado == 4) {
        state = "RECHAZADO PARCIAL";
      
      } else if (miVariables.tgmReclamoList.treclamo.idEstado == -1) {
        state = "ANULADO";
      }
      else {
        state = "";
      }*/

       state = miVariables.tgmReclamoList.treclamo.descripcionEstado;
      
    //console.log(miVariables.tgmReclamoList.treclamo.fechaIngreso);
    //console.log(fechaInicio);
    //console.log(fechaFinal);
    /*if (
      new Date(miVariables.tgmReclamoList.treclamo.fechaIngreso) >=
        fechaInicio &&
      new Date(miVariables.tgmReclamoList.treclamo.fechaIngreso) <= fechaFinal
    ) {*/
      //console.log(miVariables.tgmReclamoList.treclamo.fechaIngreso);
      //console.log(fechaInicio);
      //console.log(fechaFinal);
      countDat = countDat + 1;
      if (miVariables.tgmReclamoList.treclamo.ultimoEstado == 1) {
        countIngresado = countIngresado + 1;
      }if (miVariables.tgmReclamoList.treclamo.ultimoEstado == 2) {
        countProceso=countProceso+1;
      } else if (miVariables.tgmReclamoList.treclamo.ultimoEstado == 3) {
        countLiquidado=countLiquidado+1;
      } else if (miVariables.tgmReclamoList.treclamo.ultimoEstado == 4) {
        countCerrado=countCerrado+1
      }
      else if (miVariables.tgmReclamoList.treclamo.ultimoEstado == -1) {
        countAnulado=countAnulado+1;
      }else {
        countOtr = countOtr + 1;
      }

      //console.log(miVariables.tgmReclamoList.treclamo.idReclamo);
      //console.log(tip);
      //console.log(tipo);
      miVariable = [
        {
          ID: miVariables.tgmReclamoList.treclamo.idReclamo,
          RECLAMODE: tipo,
          TIPO: tip,
          FECHA: Moment(
            miVariables.tgmReclamoList.treclamo.fechaIngreso
          ).format("L"),
          ESTADO: state,
          ACCION: (
            <h3>
              {" "}
              <FaSearch title="Ver Detalle Reclamo" />
            </h3>
          ),
        },
      ];
    //}
  } else if (contador == 999999) {
    //console.log("elseif" + contador);
    miVariable = [];
  } else {
    //console.log("ekse" + contador);
    Moment.locale("es-mx");
    const descripcionesColores = window.estadosReclamos
      .filter((e) => e.mostrarGrafica == 1)
      .map((e) => ({
        descripcion: e.descripcion.trim().toUpperCase(),
        color: e.color,
      }));
    for (var i = 0; i < miVariables.tgmReclamoList.length; i++) {
      if (miVariables.tgmReclamoList[i].idDependiente === undefined) {
        //  //console.log("ingrse"+i);
        window.infoCertificado = "Elfrid";
      } else {
        ////console.log("ingse servicio"+i);
        /*axios
          .get(
            `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/dependiente/` +
              miVariables.tgmReclamoList[i].idDependiente,
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
              },
            }
          )
          .then((json) => {
            if(json.status==200){
            window.infoDependiente =
              json.data.primerNombre + " " + json.data.primerApellido;
            window.relacion = json.data.parentesco;
            }
          });*/

        window.infoDependiente =
          miVariables.tgmReclamoList[i].nombreDependiente;
        window.relacion = miVariables.tgmReclamoList[i].parentesco;
      }

      let dip = miVariables.tgmReclamoList[i].idDependiente
        ? miVariables.tgmReclamoList[i].treclamo.idReclamo
        : 0;

      if (miVariables.tgmReclamoList[i].idDependiente === undefined) {
        tip = window.clienteTitular;
        tipo = "Titular";
      } else {
        tip = window.infoDependiente;
        if (window.relacion == 0) {
          tipo = "NO ESPECIFICADO";
        } else if (window.relacion == 1) {
          tipo = "CONYUGE";
        } else if (window.relacion == 2) {
          tipo = "HIJO(A)";
        } else {
          tipo = "";
        }
      }
      /*
      if (miVariables.tgmReclamoList[i].treclamo.idEstado == 1) {
        state = "PROCESO";
      } else if (miVariables.tgmReclamoList[i].treclamo.idEstado == 2) {
        state = "CERRADO";       
      } else if (miVariables.tgmReclamoList[i].treclamo.idEstado == 3) {
        state = "RECHAZADO";
      
      } else if (miVariables.tgmReclamoList[i].treclamo.idEstado == 4) {
        state = "RECHAZADO PARCIAL";
      
      } else if (miVariables.tgmReclamoList[i].treclamo.idEstado == -1) {
        state = "ANULADO";
      }
      else {
        state = "";
      }*/
      state = miVariables.tgmReclamoList[i].treclamo.descripcionEstado;
      /*if (
        new Date(miVariables.tgmReclamoList[i].treclamo.fechaIngreso) >=
          fechaInicio &&
        new Date(miVariables.tgmReclamoList[i].treclamo.fechaIngreso) <=
          fechaFinal
      ) {*/
      countDat = countDat + 1;
      /*if (miVariables.tgmReclamoList[i].treclamo.idEstado == 1) {
          countPro = countPro + 1;
        } else if (miVariables.tgmReclamoList[i].treclamo.idEstado == 2) {
          countFina = countFina + 1;
        } else {
          countOtr = countOtr + 1;
        }*/

      if (miVariables.tgmReclamoList[i].treclamo.ultimoEstado == 1) {
        countIngresado = countIngresado + 1;
      }
      if (miVariables.tgmReclamoList[i].treclamo.ultimoEstado == 2) {
        countProceso = countProceso + 1;
      } else if (miVariables.tgmReclamoList[i].treclamo.ultimoEstado == 3) {
        countLiquidado = countLiquidado + 1;
      } else if (miVariables.tgmReclamoList[i].treclamo.ultimoEstado == 4) {
        countCerrado = countCerrado + 1;
      } else if (miVariables.tgmReclamoList[i].treclamo.ultimoEstado == -1) {
        countAnulado = countAnulado + 1;
      } else {
        countOtr = countOtr + 1;
      }

      const colorEstado =descripcionesColores.find(e => e.descripcion === state.trim().toUpperCase())?.color || "black";
      datos.push({
        ACCION: (
          <FaSearch
            size={25}
            style={{ marginLeft: "10px" }}
            title="Ver Detalle Reclamo"
          />
        ),
        ID: miVariables.tgmReclamoList[i].treclamo.idReclamo,
        ESTADO:  (
            <span style={{ color: colorEstado, fontWeight: "bold" }}>
              {state}
            </span>
          ),
        ESTADO_INTERNO:  (state),
        DIAGNOSTICO:
          miVariables.tgmReclamoList[i].treclamo.tgmEnfermedadList[0].nombre,
        RECLAMODE: tipo,
        TIPO: tip,
        FECHA: Moment(
          miVariables.tgmReclamoList[i].treclamo.fechaIngreso
        ).format("L"),
      });
      //}
    }

 datos.sort((a, b) => b.ID - a.ID);
    miVariable = datos;
  }
  const defaultSorted = [
    {
      dataField: "ID",
      order: "desc",
    },
  ];

  const columns = [
    { dataField: "ACCION", text: "Detalles" , headerStyle: { width: "100px", textAlign: "left" }},    
    { dataField: "ID", text: "No. Reclamo", sort: true, headerStyle: { width: "130px", textAlign: "left" } },
    { dataField: "ESTADO", text: "Estado", sort: true , headerStyle: { width: "125px", textAlign: "left" }},    
    { dataField: "ESTADO_INTERNO", text: "Estado", sort: true, hidden: true, headerStyle: { width: "110px", textAlign: "left" }},    
    { dataField: "DIAGNOSTICO", text: "Diagnóstico", headerStyle: { width: "250px", textAlign: "left" } },
    { dataField: "TIPO", text: "Nombre Reclamo", headerStyle: { width: "300px", textAlign: "left" } },
    { dataField: "RECLAMODE", text: "Tipo / Parentesco", headerStyle: { width: "150px", textAlign: "left" } },    
    { dataField: "FECHA", text: "Fecha Ingreso", headerStyle: { width: "150px", textAlign: "left" } },        
  ];

  let dat = [];
  let dat2 = [];
  const handleVerLiq = (row) => {
      axios
          .get(
            `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/liquidacionReclamo/` +
              row.ID,
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
              },
            }
          )
          .then((json) => {
            if(json.status==200){
            dat = json.data;
            setModalInfo2(row);          
            setModalInfo3(json.data.liqidacionReclamo.dirigidoA);
            setModalInfo4(json.data.liqidacionReclamo.numeroChequeTrans);
            setModalInfo6(Moment(json.data.liqidacionReclamo.fechaLiquidacion).format("L"));
            
            window.rectab = row;            
            }
          });

          /*
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/liq_bitacora/` +
              row.ID,
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
              },
            }
          )
          .then((json) => {
            if(json.status==200){
            dat2 = json.data;
            setModalInfo5(json.data.tRecLogUsuario[0].log);
            setModalInfo6(
              Moment(json.data.tRecLogUsuario[0].fechaLog).format("L")
            );
            }
          });*/
        setModalInfo2(row);
        //setModalInfo3(dat.dirigidoA);
        //setModalInfo4(dat.numeroCheque);
        //setModalInfo5(dat.tRecLogUsuario.log);
        window.rectab = row;
        toogleTrueFalse2();    
  }

  const rowEvents = {
    onClick: (e, row) => {
      //console.log(row.ESTADO);
     // if (row.ESTADO == "CERRADO") {
        //console.log("ingrese aca");
        /*axios
          .get(
            `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/totalliq/` +
              row.ID,
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
              },
            }
          )
          .then((json) => {
            if(json.status==200){
            dat = json.data;
            setModalInfo2(row);
            setModalInfo3(json.data.dirigidoA);
            setModalInfo4(json.data.numeroCheque);
            window.rectab = row;
            //toogleTrueFalse2();
            }
          });
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/liq_bitacora/` +
              row.ID,
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
              },
            }
          )
          .then((json) => {
            if(json.status==200){
            dat2 = json.data;
            setModalInfo5(json.data.tRecLogUsuario.log);
            setModalInfo6(
              Moment(json.data.tRecLogUsuario.fechaLog).format("L")
            );
            }
          });
        setModalInfo2(row);
        setModalInfo3(dat.dirigidoA);
        setModalInfo4(dat.numeroCheque);
        //setModalInfo5(dat.tRecLogUsuario.log);
        window.rectab = row;
        toogleTrueFalse2();*/
     // } else {
        //console.log("ingrese a apertura");
        const idPoliza = sessionStorage.getItem("idPoliza"); 
        if(idPoliza)
        {
          axios
            .get(
              `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/usuario_reclamo/` +
                idPoliza,
              {
                headers: {
                  Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
                },
              }
            )
            .then((json) => {
              if (json.status === 200) {
                //console.log("Datos asesor: ", json.data);
                //setdatoAsesor(json.data.contacto);
                sessionStorage.setItem("datosAsesor",json.data.contacto);
              } else {
                swal("Error", "Validando informacion General", "warning");
              }
            })
            .catch(function (error) {
              swal(
                "Error",
                "Debes validar tu usuario y contraseña, si no cuentas con usuario puedes crearlo en la opción Crear Usuario",
                "warning"
              );
            });
        }
        setModalInfo1(row);
        window.rectab = row;
        toogleTrueFalse1();
      //}
    },
  };

  

  // en esta parte obtengo los estados de los reclamos que setiamos en el login
  // y entonces generamos dos array uno para los labels de la grafica y otro para los colores
  // Array de descripciones
  const descripcionesColores = window.estadosReclamos
  .filter(e => e.mostrarGrafica == 1)
  .map(e => ({
    descripcion: e.descripcion.trim().toUpperCase(),
    color: e.color
  }));

  const descripciones = descripcionesColores.map(e => e.descripcion);
  const colores = descripcionesColores.map(e => e.color);
  

  const conteos = {
  "INGRESADO":countIngresado,  
  "PROCESO": countProceso,
  "LIQUIDACIÓN":countLiquidado,
  "CERRADO": countCerrado,
  "ANULADO": countAnulado
  };
 
 const dataGrafica = descripciones.map(
   (desc) => conteos[desc.trim().toUpperCase()] || 0
 );

 const data = {
   labels: descripciones.map((descripcion) => t(descripcion)),
   datasets: [
     {
       label: t("# de reclamos"),
       data: dataGrafica,
       display: true,
       backgroundColor: colores,
       borderColor: ["rgba(130, 130, 130)", "rgba(100, 101, 108)"],
       borderWidth: 1       
     },     
   ]
   
 };

 const options = {
  plugins: {
    legend: {
      onClick: () => {        
      },
    },
  },
};

  const toogleTrueFalse1 = () => {
    setShowModal1(handleShow1);
  };

  const toogleTrueFalse2 = () => {
    setShowModal2(handleShow2);
  };

  const Digitalizar = (valor) => {
    var element = document.getElementById("drop");
    var estado = element.style.display;
    if (estado == "none") {
      element.style.display = "block";
    } else {
      element.style.display = "none";
    }
  };

  const Generar = () => {
    //console.log(window.datoArchivoN);
    //console.log(modalInfo1.ID);
    setFiles(window.datoArchivoN);
    ////console.log(files);

    //custom-file-input
    const formData = new FormData();
    ////console.log(window.miVariable);
    // Update the formData object
    formData.append(
      "codigo_aseguradora",
      window.miVariable.tPolCertificado.idPoliza.idAseguradora.idAseguradora
    );
    formData.append(
      "codigo_tipo_poliza",
      window.miVariable.tPolCertificado.idPoliza.idTipoPoliza.codigoTipoPoliza
    );
    formData.append(
      "numero_poliza",
      window.miVariable.tPolCertificado.idPoliza.numero_poliza
    );
    formData.append("id_reclamo", modalInfo1.ID);
    formData.append("rec_id_pais", 1);
    formData.append("operacion", 9);
    for (var i = 0; i < files[0].length; i++) {
      //console.log(i);
      //console.log(files[i]);
      //console.log(files[0][i].name);
      formData.append("archivos[]", files[0][i], files[0][i].name);
    }

    var data = formData;
    //console.log(data);
    var url = `${process.env.REACT_APP_API_URL}/Gestion_Reclamo`;
    $.ajax({
      type: "POST",
      url: url,
      enctype: "multipart/form-data",
      processData: false,
      contentType: false,
      cache: false,
      data: data,
      success: function (digita) {
        var res = eval(digita);
        if (res[0] === "false") {
          swal(
            {
              title: "Somit Regional",
              text: "No fue posible digitalizar, su sesión ha finalizado, vuelva a ingresar por favor.",
              type: "error",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#7c211e",
              confirmButtonClass: "btn-danger",
              confirmButtonText: "aceptar",
              closeOnConfirm: true,
              closeOnCancel: false,
            },
            function (isConfirm) {}
          );
        } else {
          var result = "";
          for (var i = 0; i < res.length; i++) {
            result = result + res[i] + "\n";
          }
          //                  swal('Somit Regional', result, 'warning');
        }
      },
      complete: function () {
        //console.log(modalInfo1.ID);

        swal(
          "Exitoso",
          "Se ha cargado tu información correctamente y notificado al asesor de tu reclamo",
          "success"
        );
      },
      error: function (digita) {},
    });

    return false;
  };

  const ModalContent = () => {
    $("#drop").hide();
    return (
      <Modal
        size="xl"
        style={{ maxWidth: "1600px", width: "100%" }}
        show={show1}
        onHide={handleClose1}
      >
        <Modal.Header
          style={{ background: "#003479", color: "white" }}
          closeButton
        >
          <Modal.Title>Reclamo No: {modalInfo1.ID}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>           
           {/*estado cerrado, anulado*/ !["CERRADO","ANULADO"].includes(window.rectab.ESTADO_INTERNO)&& (
              <Button
                onClick={() => Digitalizar(modalInfo1.ID)}
                style={{ background: "#872434", color: "#fffff", marginLeft:"20px" }}
              ><FaPlus />Añadir archivos
              </Button> 
              )
            }
            <Col md={5}>
              <Button
                onClick={() => enviar_contacto()}
                style={{ background: "rgb(57 155 57)", color: "#fffff" }}
              >
                <FaWhatsapp size={25} />
                &nbsp;Asesor
              </Button>
            </Col>
            <Col md={3} className="text-right">
              {["CERRADO","LIQUIDACIÓN"].includes(window.rectab.ESTADO_INTERNO)&& (
                   <DescargarDoc numeroGestion={(window.rectab.ID)} tipoGestion="1" titulo="Descargar Liquidación" />
              )}
            </Col>
            <Col md={2} className="text-right">
              {["CERRADO","LIQUIDACIÓN"].includes(window.rectab.ESTADO_INTERNO) && (
                <div>
                 
                  <Button
                    onClick={() => handleVerLiq(window.rectab)}
                    style={{ background: "#872434", color: "#ffffff" }}
                  >
                    <FileText size={16} className="me-2" /> Ver Liquidación
                  </Button>                   
                </div>
              )}
            </Col>
              
          </Row>
          <br></br>
          <div id="drop" name="drop" style={{ display: "none" }}>
           <DocPendientes numeroGestion={modalInfo1.ID} tipoGestion={1}/>
          </div>
          <br></br>

          <Bitacora />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    );
  };
  const ModalContentLiq = () => {
    return (
      <Modal
        size="xl"
        style={{ maxWidth: "1600px", width: "100%" }}
        show={show2}
        onHide={handleClose2}         
      >
        <Modal.Header
          style={{ background: "rgb(135, 36, 52)", color: "white" }}          
          closeButton
          closeVariant="white"         
        >
          <Modal.Title>Liquidación de Reclamo No: {modalInfo2.ID}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <strong>Detalle Liquidacion</strong>
          <hr style={{ background: "#872434", size: 5, color: "#872434" }} />
          <FormGroup row>
            <Col md="4">
              <Label>
                {" "}
                <strong>Numero de Cheque / Transferencia:</strong>
              </Label>

              <Input value={modalInfo4} disabled />
            </Col>
            <Col md="4">
              <Label>
                <strong>Dirigido a:</strong>
              </Label>

              <Input value={modalInfo3} disabled />
            </Col>
            <Col md="4">
              <Label>
                <strong>Fecha Liquidación:</strong>
              </Label>

              <Input value={modalInfo6} disabled />
            </Col>
            {/*<Col md="12">
              <Label>
                <strong>Observaciones Liquidacion:</strong>
              </Label>
            </Col>
            <Col md="12">
              <Input rows="8" type="textarea" value={modalInfo5} disabled />
            </Col>*/}
          </FormGroup>

          <Tabs />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    );
  };
  return (
    <FormGroup row>
      <Col md="12" className="d-flex justify-content-end">
        <div
          className="form-check form-switch"
          style={{
            color: "#872434",
            fontWeight: "bold",
            fontSize: "15px",
            marginTop: "10px",
          }}
        >
          <input
            className="form-check-input"
            type="checkbox"
            id="toggleGrafica"
            checked={mostrarGrafica}
            onChange={() => setMostrarGrafica(!mostrarGrafica)}
            style={{
              width: "17px", // Aumenta el tamaño del toggle
              height: "17px", // Ajusta la altura
              cursor: "pointer",
              accentColor: "#872434", // Cambia el color del toggle (modern browsers)
            }}
          />
          <label className="form-check-label" htmlFor="toggleGrafica">
            Mostrar Gráfica
          </label>
        </div>
      </Col>
      
      {/* Gráfica */}
      {mostrarGrafica && (
        <Col md="4">
          <h4>Reclamos Ingresados: &nbsp; {countDat}</h4>
          <Pie data={data} options={options} />
          <br />
        </Col>
      )}

      {/* Tabla */}
      <Col md={mostrarGrafica ? "8" : "12"}>
        <div className="tabla-contenedor">
          <div className="table-responsive">
            <BootStrapTable
              keyField="ID"
              data={miVariable}
              columns={columns}
              rowEvents={rowEvents}
              defaultSorted={defaultSorted}
              bootstrap4
              striped
              hover
              bordered={false}
              classes="tabla-personalizada"
              noDataIndication="No hay datos disponibles"
              pagination={paginationFactory({
                nextPageText: "Siguiente",
                prePageText: "Anterior",
                firstPageText: "Primera",
                lastPageText: "Última",
                showTotal: true,
                paginationTotalRenderer: (from, to, size) => (
                  <span style={{ marginLeft: "10px" }}>{size} registros</span>
                ),
                sizePerPageList: [
                  { text: "10", value: 10 },
                  { text: "20", value: 20 },
                  { text: "30", value: 30 },
                  { text: "Todos", value: 9999 },
                ],
              })}
            />
          </div>
        </div>
      </Col>

      {/* Modales */}
      {show1 && <ModalContent />}
      {show2 && <ModalContentLiq />}
    </FormGroup>
  );
};
export default Pagination;
